import { Button, ButtonProps, Input } from '@mui/material';
import styled from 'styled-components';

export const HeaderContainer = styled.header`
  background-color: #fff;
  color: #000080;
  padding: 12px;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 10000;
  box-shadow: rgba(25, 31, 40, 0.15) 0px 6px 24px 0px;
  opacity: 0.98;

  @media (max-width: 735px) {
    position: relative;
  }
`;

export const HeaderContent = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-left: 20px; /* Nova regra para adicionar espaçamento à esquerda */

  @media (max-width: 735px) {
    flex-direction: column;
    align-items: center;
  }
`;

export const HeaderLogo = styled.div`
  display: flex;
  align-items: center;
  cursor: pointer;
  transition: opacity ease-in 150ms;

  &:hover {
    opacity: 0.75;
  }
`;

export const HeaderStart = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  gap: 2em;
  width: 100%;

  @media (max-width: 640px) {
    gap: 1em;
    width: 100%;
  }
`;

export const HeaderButtons = styled.div`
  width: 100%;
  text-align: end;

  @media (max-width: 735px) {
    display: none;
  }

  button {
    font-size: small;
    font-weight: bold;
  }
`;

export const SearchInput = styled(Input).attrs(() => ({
  disableUnderline: true,
}))`
  && {
    display: flex;
    align-items: center;
    border: 1px solid #e0e0e0;
    border-radius: 8px;
    padding: 5px 10px;
    background-color: #fafafa;
    max-width: 70vh;
    transition: 0.3s ease;

    &:focus-within {
      border-color: #000080;
      background-color: #fff;
      box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
    }

    @media (max-width: 735px) {
      max-width: 100%;
    }
  }

  svg {
    color: #000080;
    margin-right: 8px;
  }
`;

// Estilos para a barra de navegação estilo aplicativo
export const HeaderCenter = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex: 1;
`;

export const AppNavbar = styled.div<{ $issmallscreen: string }>`
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: #fff;
  display: flex;
  justify-content: space-around;
  border-top: 1px solid #ccc;
  padding: 10px;
  transition: transform 0.3s ease;
  transform: translateY(${(props) => (props.$issmallscreen === 'true' ? '0' : '100%')});
  z-index: 2;

  span {
    font-size: 12px;
    color: #808080;
    margin-top: 4px;
  }
`;

export const AppNavItemContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const AppNavItem = styled.div<{ $active?: string }>`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: ${(props) => (props.$active === 'true' ? '#000080' : '#808080')};
  cursor: pointer;

  &:hover {
    color: #000080;
  }
`;

export const CartPopOverButtons = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 10px;
`;

export const CartPopOverButton = styled(Button)<ButtonProps>`
  background-color: #00ddcc !important;
  padding: 8px 16px;
`;
